import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


const CustomerFarms = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  let customer_id = localStorage.getItem("customer_id");
  
  const formData = ({
    customer:customer_id,    
  });
  console.log(formData);
  useEffect(() => {
    axios.post("/customerportal/farmers/listings",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.farmers);
        }
        else  if (response.data.code === 401) {
         // window.location.href = "/customerportal/login";
        }else{
        //  window.location.href = "/customerportal/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const FarmNameCell = ({ row }) => {
    return (
      <a href={`/customerportal/farms-view/${row.original.id}`}>
        {row.original.name}
      </a>
    );
  };
  
  FarmNameCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
      }),
    }).isRequired,
  };
const columns =
 [
   
   
      {
        header: 'Farm Name',
        accessorFn: (row) => row.name,
        Cell: FarmNameCell,
      }

,
    {
      accessorKey: 'location', //normal accessorKey
      header: 'GPS Location',
    },
    {
      accessorKey: 'ggn_number', //normal accessorKey
      header: 'GGN Number',
    },
   
  ];

  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Farms</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                  <Link to="/customerportal/profile">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Farms</li>
                </ul>
              </div>
              
            </div>
          </div>

          <div className="row">
           
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                    // enableColumnFilterModes
                    enableColumnOrdering
                    // enableGrouping
                    enablePinning
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerFarms;
